var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2051_199146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 12.9998C14.4469 12.9998 13.9999 13.4479 13.9999 13.9997V17.9998C13.9999 18.5508 13.5519 18.9997 12.9998 18.9997H9.99983V3.9999C9.99983 3.1459 9.45583 2.38291 8.63791 2.09892L8.34183 1.99986H12.9998C13.5519 1.99986 13.9999 2.44883 13.9999 2.99997V5.99994C13.9999 6.55181 14.4469 6.99987 14.9998 6.99987C15.5528 6.99987 15.9998 6.55181 15.9998 5.99994V2.99997C15.9998 1.34599 14.6538 0 12.9998 0H2.24998C2.21189 0 2.18003 0.0170287 2.14304 0.0219724C2.09489 0.0179442 2.04893 0 2.00004 0C0.897024 0 0 0.896841 0 1.99986V19.9997C0 20.8537 0.544001 21.6167 1.36192 21.9007L7.37999 23.9067C7.58397 23.9697 7.78684 23.9997 7.99998 23.9997C9.10299 23.9997 9.99983 23.1027 9.99983 21.9997V20.9998H12.9998C14.6538 20.9998 15.9998 19.6538 15.9998 17.9998V13.9997C15.9998 13.4479 15.5528 12.9998 14.9998 12.9998Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7067 9.29317L19.7067 5.29327C19.4208 5.00726 18.9907 4.9212 18.6168 5.07611C18.2438 5.2312 17.9998 5.59612 17.9998 6.00023V9.0002H13.9999C13.4478 9.0002 12.9998 9.44807 12.9998 10.0001C12.9998 10.5522 13.4478 11.0001 13.9999 11.0001H17.9998V14C17.9998 14.4041 18.2438 14.7691 18.6168 14.9241C18.9907 15.0791 19.4208 14.993 19.7067 14.7072L23.7067 10.7071C24.0977 10.3162 24.0977 9.68409 23.7067 9.29317Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2051_199146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.0bc4eab2c304a623db131917aa17a697.svg";
export { ForwardRef as ReactComponent };